import type {SelfHostedRequirement} from '../EditPipelinePage/SettingsSidebarContent/JobSettingsSidebar/JobAgentRequirements/SelfHosted/Requirements/SelfHostedRequirements.types'

export enum HTTPCodes {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
}

export interface HTTPError {
  statusCode: number | undefined
  url: string | null | undefined
  response: Response | undefined
}

export function instanceOf<T>(object: any, member: string): object is T {
  return member in object
}

export enum ParameterNames {
  PIPELINE_HEAD = 'teamcity.internal.pipelines.isPipelineHead',
}

export enum StepTypes {
  CLI = 'script',
  MAVEN = 'maven',
  NODE = 'node-js',
  GRADLE = 'gradle',
}

export enum SuggestionType {
  CLI_TO_MAVEN = 'CliToMaven',
  CLI_TO_GRADLE = 'CliToGradle',
  CLI_DOCKER_LOGIN = 'CliDockerLogin',
  CLI_TO_WORKING_DIR = 'CliToWorkingDir',
  PARALLELISM = 'Parallelism',
  JDK_DOCKER_INFO = 'JdkDockerInfo',
}

export type Step = Record<string, string>

type DependencySettings = {
  files?: readonly string[]
}

export type Dependency = string | Record<string, DependencySettings>
export type Jobs = Record<string, Job>

export type JobRepositorySettings = {
  enabled: boolean
  path?: string
}

export type Job = {
  steps?: Step[]
  name?: string
  dependencies?: Dependency[]
  integrations?: string[]
  repositories?: Record<string, JobRepositorySettings>[]
  'files-publication'?: string[]
  'runs-on'?: RunsOn
  'checkout-working-directories-only'?: boolean
  parallelism?: number
  'allow-reuse'?: boolean
  'enable-dependency-cache'?: boolean
}

export type SelfHostedRunsOn =
  | 'self-hosted'
  | {
      ['self-hosted']: Array<SelfHostedRequirement>
    }

export type RunsOn = string | SelfHostedRunsOn

export type PipelineSettings = {
  jobs?: Jobs
  parameters?: Record<string, string>
  secrets?: Record<string, string>
}
